import { MapObjectProperties } from "@iventis/map-types";
import GeoJSON from "geojson";
import length from "@turf/length";
import { Content } from "@iventis/translations/content/typed-content";
import { Body2 } from "@iventis/styles/src/components/texts";
import React, { FunctionComponent, useState, useMemo } from "react";
import { styled } from "@iventis/styles";
import { canParseInt } from "@iventis/utilities";
import { getLengthInAppropriateUnits } from "@iventis/map-engine/src/utilities/geojson-helpers";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { NumberOnlyInput } from "@iventis/components/src/number-only-input";
import { contentCss, inputCss } from "./analysis.helpers";

export const AnalysisWalkTimeComponent: FunctionComponent<{ feature: GeoJSON.Feature<GeoJSON.LineString, MapObjectProperties>; unitOfMeasurement: UnitOfMeasurement }> = ({
    feature,
    unitOfMeasurement,
}) => {
    const translate = useIventisTranslate();
    const [speedInputValue, setSpeedInputValue] = useState<string>("1.2");
    const walkTime = useMemo(() => (canParseInt(speedInputValue) ? Math.floor(length(feature, { units: "meters" }) / Number(speedInputValue) / 60) : 0), [
        speedInputValue,
        feature,
    ]);
    return (
        <>
            <StyledContent>
                <Body2 className="bold">{translate(Content.map2.analysis.distance_content.title)}</Body2>
                <Body2>{getLengthInAppropriateUnits(feature, unitOfMeasurement)}</Body2>
            </StyledContent>
            <StyledContent>
                <Body2 className="bold">{translate(Content.map2.analysis.walk_time_content.title)}</Body2>
                <div>
                    <Body2 data-testid="walk-time-analysis-result">{translate(Content.map2.analysis.walk_time_content.approx_time, { speed: walkTime })}</Body2>
                    <NumberOnlyInput value={speedInputValue} onChange={(e) => setSpeedInputValue(e.target.value)} style={inputCss} type="number" variant="outlined" />
                    <Body2>{translate(Content.map2.analysis.walk_time_content.m_per_second)}</Body2>
                </div>
            </StyledContent>
        </>
    );
};

const StyledContent = styled.div`
    ${contentCss}
`;
